import _Gallery from './Gallery';
import _GalleryItem from './GalleryItem';

export const Gallery = _Gallery;
export const GalleryItem = _GalleryItem;



/** WEBPACK FOOTER **
 ** ./web/js/components/Gallery/index.js
 **/